module.exports = __webpack_public_path__ + "static/media/wavm8s-006-polyop.c3f4563.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-006-polyop.mp3
// module id = Gt5B
// module chunks = 0